import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://api.huberfeichter.it/api/',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Token automatisch anhängen
axiosInstance.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));

// Fehler abfangen
axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {

        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            window.location.href = '/login';
        }

        if (error.response?.status === 403) {
            return Promise.resolve({
                data: {},
                status: 403
            });
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;